// AGC: Desktop content width per page. Default is 'default' (max-w-6xl).
// AGC: 'wide' for data-dense pages (lists, grids). 'full' for maps and edge-to-edge tools.
// AGC: To change a page's width on desktop, add/edit an entry here — MainMenu does not need to be touched.
import type { ActivePage } from '../../types'

export type DesktopWidth = 'compact' | 'default' | 'wide' | 'full'

const WIDTH_CLASS: Record<DesktopWidth, string> = {
  compact: 'max-w-3xl',
  default: 'max-w-6xl',
  wide:    'max-w-screen-2xl',
  full:    'max-w-none',
}

// AGC: Entries not listed here fall back to 'default'
const PAGE_WIDTHS: Partial<Record<ActivePage, DesktopWidth>> = {
  // AGC: Dashboard fills full available width — no max-width cap; MainMenu px-6 provides edge spacing
  dashboard:    'full',
  fields:       'wide',
  'lotes-list': 'wide',
  tasks:        'default',
  weather:      'wide',
  // AGC: Map / canvas pages get full width — no centering constraint
  'auto-detect-fields': 'full',
  'polygon-map':        'full',
  'ai-one-click-lot':   'full',
  'farm-lots-map':      'full',
  // AGC: Detail / form pages stay compact
  'lot-page':           'default',
  'plot-detail':        'default',
  'task-detail':        'default',
  'lot-task-detail':    'default',
  finances:             'wide',
  inventory:            'wide',
  machinery:            'wide',
  'team-users':         'wide',
}

export const getDesktopWidthClass = (page: ActivePage): string => {
  const mode = PAGE_WIDTHS[page] ?? 'default'
  return WIDTH_CLASS[mode]
}
